import { useEffect } from "react";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800&family=DM+Sans:wght@300;400;500;600&display=swap');

  .terms-page { font-family:'DM Sans',sans-serif; background:#f8f6f0; min-height:100vh; color:#1a1a2e; }

  .terms-hero {
    background:linear-gradient(135deg,#1a1a1a 0%,#2c2c2c 50%,#1a1a2e 100%);
    padding:80px 40px 60px; position:relative; overflow:hidden;
  }
  .terms-hero::before {
    content:''; position:absolute; bottom:-30%; right:10%; width:350px; height:350px;
    background:radial-gradient(circle,rgba(255,165,0,0.1) 0%,transparent 70%); border-radius:50%;
  }
  .terms-hero::after {
    content:''; position:absolute; bottom:0; left:0; right:0; height:4px;
    background:linear-gradient(90deg,#ffa500,#ffd700,#ffa500);
  }
  .brand-badge { display:inline-flex; align-items:center; gap:10px; background:rgba(255,165,0,0.12); border:1px solid rgba(255,165,0,0.3); padding:8px 20px; border-radius:50px; margin-bottom:24px; }
  .brand-dot { width:8px; height:8px; background:#ffa500; border-radius:50%; animation:pulse 2s infinite; }
  @keyframes pulse { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:0.5;transform:scale(0.8)} }
  .brand-name { color:#ffa500; font-size:13px; font-weight:600; letter-spacing:2px; text-transform:uppercase; }
  .terms-hero h1 { font-family:'Playfair Display',serif; font-size:clamp(36px,5vw,56px); font-weight:800; color:#fff; margin:0 0 16px; line-height:1.1; }
  .terms-hero p { color:rgba(255,255,255,0.55); font-size:15px; max-width:500px; font-weight:300; }
  .policy-meta { display:flex; gap:16px; margin-top:32px; flex-wrap:wrap; }
  .meta-chip { background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.12); padding:6px 16px; border-radius:6px; color:rgba(255,255,255,0.65); font-size:12px; font-weight:500; }

  .policy-body { max-width:860px; margin:0 auto; padding:60px 40px; }

  .agree-banner { background:linear-gradient(135deg,#1a1a1a,#2c2c2c); border-radius:16px; padding:28px 32px; margin-bottom:48px; border:1px solid rgba(255,165,0,0.3); display:flex; align-items:center; gap:20px; }
  .agree-icon { font-size:36px; flex-shrink:0; }
  .agree-banner h3 { font-family:'Playfair Display',serif; color:#ffa500; margin:0 0 6px; font-size:18px; }
  .agree-banner p { color:rgba(255,255,255,0.6); margin:0; font-size:13px; line-height:1.6; }

  .toc-card { background:#fff; border:1px solid #e8e4da; border-radius:16px; padding:32px; margin-bottom:48px; box-shadow:0 2px 12px rgba(0,0,0,0.04); }
  .toc-title { font-family:'Playfair Display',serif; font-size:18px; font-weight:700; margin:0 0 20px; color:#1a1a2e; }
  .toc-list { list-style:none; padding:0; margin:0; display:grid; grid-template-columns:1fr 1fr; gap:8px; }
  .toc-item a { color:#1a1a2e; text-decoration:none; font-size:14px; font-weight:500; display:flex; align-items:center; gap:8px; padding:6px 0; transition:color 0.2s; }
  .toc-item a:hover { color:#ffa500; }
  .toc-num { width:22px; height:22px; background:#f0ece4; border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:600; color:#1a1a2e; flex-shrink:0; }

  .section-card { background:#fff; border:1px solid #e8e4da; border-radius:16px; overflow:hidden; margin-bottom:24px; box-shadow:0 2px 12px rgba(0,0,0,0.04); }
  .section-card-header { background:linear-gradient(135deg,#1a1a1a,#2c2c2c); padding:20px 28px; display:flex; align-items:center; gap:14px; }
  .section-icon { font-size:22px; }
  .section-card-header h2 { font-family:'Playfair Display',serif; font-size:20px; font-weight:700; color:#fff; margin:0; }
  .section-card-body { padding:28px; font-size:15px; line-height:1.8; color:#3a3a50; }
  .section-card-body p { margin:0 0 14px; } .section-card-body p:last-child { margin:0; }

  .rule-list { list-style:none; padding:0; margin:12px 0; }
  .rule-list li { display:flex; align-items:flex-start; gap:10px; padding:10px 0; border-bottom:1px solid #f0ece4; font-size:14px; }
  .rule-list li:last-child { border-bottom:none; }
  .rule-icon { color:#ffa500; font-weight:bold; flex-shrink:0; margin-top:3px; }

  .forbidden-list { list-style:none; padding:0; margin:12px 0; }
  .forbidden-list li { display:flex; align-items:flex-start; gap:10px; padding:10px 0; border-bottom:1px solid #fff0f0; font-size:14px; }
  .forbidden-list li:last-child { border-bottom:none; }
  .forbidden-icon { color:#e74c3c; flex-shrink:0; margin-top:3px; }

  .highlight-orange { background:linear-gradient(135deg,#fffbf0,#fff5e0); border-left:4px solid #ffa500; border-radius:0 8px 8px 0; padding:16px 20px; margin:16px 0; font-size:14px; }
  .highlight-dark { background:linear-gradient(135deg,#f5f5f7,#eeeeee); border-left:4px solid #333; border-radius:0 8px 8px 0; padding:16px 20px; margin:16px 0; font-size:14px; }
  .highlight-red { background:linear-gradient(135deg,#fff5f5,#ffe8e8); border-left:4px solid #e74c3c; border-radius:0 8px 8px 0; padding:16px 20px; margin:16px 0; font-size:14px; }
  .highlight-green { background:linear-gradient(135deg,#f0fff8,#e8fff3); border-left:4px solid #2ed573; border-radius:0 8px 8px 0; padding:16px 20px; margin:16px 0; font-size:14px; }

  .jurisdiction-box { background:linear-gradient(135deg,#1a1a1a,#2c2c2c); border-radius:12px; padding:24px; text-align:center; color:white; margin:16px 0; }
  .jurisdiction-box h4 { color:#ffa500; font-family:'Playfair Display',serif; font-size:18px; margin:0 0 8px; }
  .jurisdiction-box p { color:rgba(255,255,255,0.65); font-size:13px; margin:0; line-height:1.6; }

  .contact-card { background:linear-gradient(135deg,#1a1a1a,#2c2c2c); border-radius:16px; padding:36px; text-align:center; margin-top:48px; color:white; border:1px solid rgba(255,165,0,0.2); }
  .contact-card h3 { font-family:'Playfair Display',serif; font-size:24px; margin:0 0 12px; color:#ffa500; }
  .contact-card p { color:rgba(255,255,255,0.65); margin:0 0 24px; font-size:14px; }
  .contact-links { display:flex; justify-content:center; gap:16px; flex-wrap:wrap; }
  .contact-link { background:rgba(255,165,0,0.12); border:1px solid rgba(255,165,0,0.4); color:#ffa500; padding:10px 24px; border-radius:8px; text-decoration:none; font-size:14px; font-weight:500; transition:all 0.2s; }
  .contact-link:hover { background:#ffa500; color:#1a1a1a; }

  @media(max-width:600px) {
    .terms-hero{padding:60px 20px 40px} .policy-body{padding:40px 20px}
    .toc-list{grid-template-columns:1fr} .section-card-body{padding:20px}
    .agree-banner{flex-direction:column;text-align:center}
  }
`;

const sections = [
  {
    id: "acceptance", icon: "📜", title: "Acceptance of Terms",
    content: (<>
      <p>By using the ITI Expert Guruji platform, you are deemed to have agreed to these Terms & Conditions. If you do not agree, please discontinue use of the platform immediately.</p>
      <ul className="rule-list">
        <li><span className="rule-icon">◆</span> Parental consent is required for students under 18 years of age</li>
        <li><span className="rule-icon">◆</span> When enrolled through a school or college, the institution is responsible</li>
        <li><span className="rule-icon">◆</span> ITI Expert Guruji reserves the right to modify these Terms at any time</li>
      </ul>
      <div className="highlight-orange"><strong>📌 Note:</strong> Using the platform implies you have read and accepted all these Terms.</div>
    </>),
  },
  {
    id: "account", icon: "👤", title: "Account & Registration",
    content: (<>
      <p>The following rules apply when creating and using your ITI Expert Guruji account:</p>
      <ul className="rule-list">
        <li><span className="rule-icon">◆</span> Accurate and truthful information is mandatory during registration</li>
        <li><span className="rule-icon">◆</span> Each individual may create only one account</li>
        <li><span className="rule-icon">◆</span> You are responsible for keeping your password confidential</li>
        <li><span className="rule-icon">◆</span> Account sharing or transfer to another person is strictly prohibited</li>
        <li><span className="rule-icon">◆</span> ITI Expert Guruji may suspend an account if suspicious activity is detected</li>
      </ul>
      <div className="highlight-dark">You are responsible for all activity occurring under your account. Report any unauthorized access immediately to msmahajan79@gmail.com</div>
    </>),
  },
  {
    id: "content-usage", icon: "📚", title: "Content Usage Rules",
    content: (<>
      <p>All educational materials on ITI Expert Guruji (videos, PDFs, tests, notes) may only be used under the following terms:</p>
      <div className="highlight-green"><strong>✅ Permitted:</strong> Downloading or streaming for personal study, taking notes, attempting tests, earning certificates</div>
      <ul className="forbidden-list">
        <li><span className="forbidden-icon">✗</span> Recording and sharing or selling content to others</li>
        <li><span className="forbidden-icon">✗</span> Screen recording or sharing screenshots publicly</li>
        <li><span className="forbidden-icon">✗</span> Uploading content to YouTube or any social media platform</li>
        <li><span className="forbidden-icon">✗</span> Distributing paid content to others for free</li>
        <li><span className="forbidden-icon">✗</span> Reverse engineering or attempting to hack any course or platform</li>
      </ul>
      <div className="highlight-red"><strong>⚠️ Violation:</strong> Consequences include permanent account ban, legal action, and recovery of damages.</div>
    </>),
  },
  {
    id: "ip", icon: "©️", title: "Intellectual Property",
    content: (<>
      <p>All content, design, trademarks, and intellectual property on the ITI Expert Guruji platform belong to ITI Expert Guruji Education Pvt. Ltd.</p>
      <ul className="rule-list">
        <li><span className="rule-icon">◆</span> Use of the ITI Expert Guruji name, logo, or brand identity is prohibited without permission</li>
        <li><span className="rule-icon">◆</span> Copyright of course materials belongs to ITI Expert Guruji and the respective expert educators</li>
        <li><span className="rule-icon">◆</span> Limited use for academic research is permitted with proper attribution</li>
        <li><span className="rule-icon">◆</span> Third-party content (e.g. textbook excerpts) remains the property of respective owners</li>
      </ul>
    </>),
  },
  {
    id: "conduct", icon: "🎓", title: "Student Code of Conduct",
    content: (<>
      <p>ITI Expert Guruji is an educational platform. Students are expected to follow the code of conduct below:</p>
      <ul className="rule-list">
        <li><span className="rule-icon">◆</span> Maintain respectful behavior during live classes</li>
        <li><span className="rule-icon">◆</span> Use polite and appropriate language in Q&A sections</li>
        <li><span className="rule-icon">◆</span> Avoid spam, advertisements, or off-topic posts</li>
        <li><span className="rule-icon">◆</span> Harassment or bullying of other students is strictly prohibited</li>
        <li><span className="rule-icon">◆</span> Cheating or impersonation in tests or exams is not allowed</li>
      </ul>
      <div className="highlight-red"><strong>⚠️ Violations may result in:</strong> Warning, suspension, or permanent ban — at ITI Expert Guruji's sole discretion.</div>
    </>),
  },
  {
    id: "liability", icon: "⚖️", title: "Limitation of Liability",
    content: (<>
      <p>ITI Expert Guruji is not liable for the following:</p>
      <ul className="forbidden-list">
        <li><span className="forbidden-icon">—</span> Losses resulting from internet connectivity issues</li>
        <li><span className="forbidden-icon">—</span> Device compatibility issues on the user's end</li>
        <li><span className="forbidden-icon">—</span> Guaranteed exam results or career outcomes</li>
        <li><span className="forbidden-icon">—</span> Content on third-party linked websites</li>
        <li><span className="forbidden-icon">—</span> Service interruption due to force majeure (natural disasters, server attacks, etc.)</li>
      </ul>
      <div className="highlight-orange"><strong>📌 Maximum Liability:</strong> Under no circumstances shall ITI Expert Guruji's total liability exceed the course fee paid by the user.</div>
    </>),
  },
  {
    id: "termination", icon: "🚫", title: "Account Termination",
    content: (<>
      <p><strong>By You:</strong> You may delete your account at any time. Access continues until the end of any active subscription period, but no refund will be issued.</p>
      <p><strong>By ITI Expert Guruji:</strong> Your account may be terminated for the following reasons:</p>
      <ul className="forbidden-list">
        <li><span className="forbidden-icon">✗</span> Violation of Terms & Conditions</li>
        <li><span className="forbidden-icon">✗</span> Content piracy or unauthorized sharing</li>
        <li><span className="forbidden-icon">✗</span> Fraudulent payment or chargebacks</li>
        <li><span className="forbidden-icon">✗</span> Abusive behavior on the platform</li>
      </ul>
      <div className="highlight-dark">After termination, your data is retained for 30 days before being permanently deleted.</div>
    </>),
  },
  {
    id: "jurisdiction", icon: "🏛️", title: "Governing Law & Jurisdiction",
    content: (<>
      <p>These Terms & Conditions are governed by the laws of India:</p>
      <div className="jurisdiction-box">
        <h4>⚖️ Jurisdiction</h4>
        <p>In the event of any dispute, the courts of Maharashtra shall have exclusive jurisdiction. The IT Act 2000, Consumer Protection Act 2019, and Indian Contract Act 1872 shall apply.</p>
      </div>
      <p>Disputes will first be attempted to be resolved amicably or through arbitration. Arbitration proceedings will be conducted in Pune, Maharashtra.</p>
    </>),
  },
  {
    id: "changes", icon: "🔄", title: "Changes to These Terms",
    content: (<>
      <p>ITI Expert Guruji may update these Terms at any time. When changes occur:</p>
      <ul className="rule-list">
        <li><span className="rule-icon">◆</span> The updated version will be published immediately on the website</li>
        <li><span className="rule-icon">◆</span> Registered users will receive an email notification</li>
        <li><span className="rule-icon">◆</span> For significant changes, a 15-day prior notice will be provided</li>
        <li><span className="rule-icon">◆</span> Continued use of the platform after changes implies acceptance of the new Terms</li>
      </ul>
    </>),
  },
];

export default function TermsAndConditions() {
  useEffect(() => {
    const el = document.createElement("style");
    el.textContent = styles;
    document.head.appendChild(el);
    return () => document.head.removeChild(el);
  }, []);

  return (
    <div className="terms-page">
      <div className="terms-hero">
        <div className="brand-badge"><div className="brand-dot" /><span className="brand-name">ITI Expert Guruji</span></div>
        <h1>Terms & Conditions</h1>
        <p>Please read these terms carefully before using the ITI Expert Guruji platform.</p>
        <div className="policy-meta">
          <span className="meta-chip">📅 Effective: January 1, 2025</span>
          <span className="meta-chip">⚖️ Governed by Indian Law</span>
          <span className="meta-chip">📍 Pune, Maharashtra</span>
        </div>
      </div>

      <div className="policy-body">
        <div className="agree-banner">
          <div className="agree-icon">📋</div>
          <div>
            <h3>Important — Before Using This Platform</h3>
            <p>By using ITI Expert Guruji, you automatically agree to these Terms & Conditions. Using the platform, creating an account, or purchasing any course means you have read, understood, and accepted all of the following terms.</p>
          </div>
        </div>

        <div className="toc-card">
          <h2 className="toc-title">Table of Contents</h2>
          <ul className="toc-list">
            {sections.map((s, i) => (
              <li key={s.id} className="toc-item">
                <a href={`#${s.id}`}><span className="toc-num">{i + 1}</span>{s.title}</a>
              </li>
            ))}
          </ul>
        </div>

        {sections.map((section) => (
          <div key={section.id} id={section.id} className="section-card">
            <div className="section-card-header">
              <span className="section-icon">{section.icon}</span>
              <h2>{section.title}</h2>
            </div>
            <div className="section-card-body">{section.content}</div>
          </div>
        ))}

        <div className="contact-card">
          <h3>Questions About Our Terms?</h3>
          <p>Contact our legal team for any clarification regarding these Terms</p>
          <div className="contact-links">
            <a href="mailto:msmahajan79@gmail.com" className="contact-link">✉ msmahajan79@gmail.com</a>
            <a href="tel:+91 9421989575" className="contact-link">📞 +91 9421989575</a>
          </div>
        </div>
      </div>
    </div>
  );
}
